import { Component } from 'react';
import { format_bytes, format_number, format_throughput, MISSION_COLOR_PALETTE } from '../../utils/data';
import Chart from 'react-apexcharts';
import { v4 } from 'uuid';
import MediaModal from '../MediaModal/MediaModal';

interface Props {
    title: string
    data: any
    size?: boolean
    width?: number
    data_rate?: boolean
    colors?: Array<string>
    selection?: Array<number>
    chartData?: { url: string, info: string }
    throughput?: boolean
}

interface State {
    main_data: any
    filtered_main_data: any
    chart_dates: any
    // chart_last_date: Date

    selection_min: number
    selection_max: number
    selection_min_update?: number
    selection_max_update?: number

    chart_min: number
    chart_max: number
    slider_data: any

}

export default class CumulativeWeeklyDataChart extends Component<Props, State> {
    id: string
    slider_id: string

    constructor(props: Props) {
        super(props);
        this.id = `${this.props.title.toLowerCase().replace(/\s/g, '')}-weekly-stats-${v4()}`;
        this.slider_id = this.id + '_slider';
        this.state = {
            ...this.init_charts()
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.data !== prevProps.data) {
            this.setState({
                ...this.init_charts()
            })
        }
    }

    update_slider_data = () => {
        // Update chart values
        this.setState({
            ...this.get_slider_data(this.state.main_data)
            // ...this.get_chart_data()
        })
    }

    init_charts = () => {
        let chart_dates = this.props.data[0].values.map((d: any) => { return d.date });
        let chart_last_date = new Date(chart_dates[chart_dates.length - 1]);

        let selection_min = chart_last_date.getTime() - 6 * 29 * 24 * 60 * 60 * 1000;
        let selection_max = chart_last_date.getTime();

        return {
            ...this.get_chart_data(selection_min, selection_max),
            chart_dates,
            selection_min,
            selection_max,
        }
    }

    get_chart_data = (selection_min: number, selection_max: number) => {
        let main_data = this.props.data.map((serie: any) => {
            return {
                visible: true,
                name: serie.key,
                data: serie.values?.map((value: any) => { return { y: value.value, x: new Date(value.date).getTime() } })
            }
        })
        // main_data = main_data.filter((serie:any) => serie.visible !== false);

        return {
            main_data,
            ...this.get_slider_data(main_data),
            ...this.filter_main_data(main_data, selection_min, selection_max)
        }
    }

    get_slider_data = (main_data: any[]) => {
        let filtered = main_data.filter((serie) => serie.visible !== false);
        // let filtered = main_data;

        let _max_data = [];
        let biggest = 0;
        for (let i = 0; i < this.props.data[0].values.length; i++) {
            let vals: Array<number> = filtered.map((serie: any) => { return serie.data[i].y });
            let cumul = vals.reduce((a, b) => { return a + b }, 0);
            _max_data.push(cumul);
            if (biggest < cumul) biggest = cumul;
        }

        let chart_min = 0;
        let chart_max = biggest * 1.1;

        return {
            chart_min,
            chart_max,
            slider_data: [{
                name: this.props.title,
                data: _max_data
            }],
        }
    }
    // update_charts = (main_data: any[]) => {

    // }

    toggle_legend_data(_seriesIndex: any) {
        // The following line do not remove data related to the legend clicked by just toggle the key visible
        this.state.main_data[_seriesIndex].visible = !this.state.main_data[_seriesIndex].visible;

        // Refresh the slider component with or without the selected legend
        this.update_slider_data();
        this.setState({
            ...this.filter_main_data(this.state.main_data, this.state.selection_min, this.state.selection_max)
        })
    }

    filter_main_data(main_data: any[], selection_min: number, selection_max: number) {
        let larger_min = selection_min - 21 * 24 * 60 * 60 * 1000;
        let larger_max = selection_max + 21 * 24 * 60 * 60 * 1000;
        let filtered_main_data = main_data.map((serie) => {
            return {
                ...serie,
                data: serie.data.filter((d: { x: number, y: number }) =>
                    new Date(d.x).getTime() >= larger_min && new Date(d.x).getTime() <= larger_max
                )
            }
        })
        return {
            filtered_main_data
        }
    }


    render = () => {
        let main_width = this.props.width || 500;
        let main_height = 300;
        let slider_width = this.props.width || 500;
        return (
            <div className="date-slide-chart">
                <div className="chart-title">
                    {this.props.title}
                    {
                        !!this.props.chartData &&
                        <MediaModal chartData={this.props.chartData} />
                    }
                </div>
                <div className="date-slide-chart-chart"
                    onMouseUp={() => {
                        if (this.state.selection_min_update && this.state.selection_max_update) {
                            console.log("updated")
                            this.setState({
                                selection_min: this.state.selection_min_update,
                                selection_max: this.state.selection_max_update
                            }, () => {
                                this.setState({
                                    ...this.filter_main_data(this.state.main_data, this.state.selection_min, this.state.selection_max)
                                })
                            })
                        }
                    }}
                >
                    {/* MAIN CHART */}
                    <Chart
                        height={main_height}
                        width={main_width}
                        type="bar"
                        // series={this.state.main_data}
                        series={this.state.filtered_main_data}
                        options={{
                            colors: this.props.colors || MISSION_COLOR_PALETTE,
                            grid: {
                                padding: {
                                    bottom: 0
                                },
                            },
                            legend: {
                                show: true,
                                showForSingleSeries: true,
                                position: 'right'
                            },
                            // labels: this.state.chart_dates,
                            chart: {
                                stacked: true,
                                animations: { enabled: false },
                                height: main_height,
                                id: this.id,
                                toolbar: {
                                    show: false,
                                    autoSelected: 'pan'
                                },
                                events: {
                                    legendClick: (chartContext, seriesIndex, config) => {
                                        this.toggle_legend_data(seriesIndex)
                                    },
                                }
                            },
                            xaxis: {
                                type: 'datetime',

                                min: this.state.selection_min,
                                max: this.state.selection_max
                            },
                            yaxis: {
                                labels: {
                                    formatter: (value) => {
                                        return this.props.throughput ?
                                            `${format_throughput(value, { decimals: 0, base: 1000 })}${this.props.data_rate ? '/s' : ''}`
                                            : this.props.size ?
                                                `${format_bytes(value, { decimals: 0, base: 1000 })}${this.props.data_rate ? '/s' : ''}`
                                                :
                                                `${format_number(value, 1)}`;
                                    },
                                },
                                min: this.state.chart_min,
                                max: this.state.chart_max
                            },
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                opacity: 1,
                                type: 'solid'
                            },
                        }}
                    />



                    {/* SLIDER CHART */}

                    <Chart
                        height={100}
                        width={slider_width - 100}
                        type="bar"
                        series={this.state.slider_data}
                        options={{
                            labels: this.state.chart_dates,
                            grid: {
                                show: false,
                                padding: {
                                    top: 0
                                },
                            },
                            chart: {
                                id: this.slider_id,
                                animations: { enabled: false },
                                height: 100,
                                toolbar: {
                                    autoSelected: 'selection',
                                },
                                brush: {
                                    enabled: true,
                                    target: this.id
                                },
                                selection: {
                                    enabled: true,
                                    xaxis: {
                                        min: this.state.selection_min,
                                        max: this.state.selection_max
                                    }
                                },
                                events: {
                                    selection: (chart: any, options: any) => {
                                        this.setState({
                                            selection_min_update: options.xaxis.min,
                                            selection_max_update: options.xaxis.max


                                        })
                                    }
                                }
                            },
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                opacity: 1,
                                type: 'solid'
                            },
                            xaxis: {
                                tickAmount: 3,
                                type: 'datetime',
                            },
                            yaxis: {
                                tickAmount: 3,
                                min: this.state.chart_min,
                                max: this.state.chart_max,
                                labels: {
                                    show: false
                                },
                            },
                        }}
                    />
                </div>
            </div>
        )
    }
}